/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} History_AllInputs */

const en_history_all = /** @type {(inputs: History_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`See all ${i?.count}`)
};

const de_history_all = /** @type {(inputs: History_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} ansehen`)
};

/**
* | output |
* | --- |
* | "See all {count}" |
*
* @param {History_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_all = /** @type {((inputs: History_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_all(inputs)
	return en_history_all(inputs)
});